<small class="debug"> {{me}} </small>
<div>
    <h2 class="form-signin-heading"></h2>
    <mat-form-field>
        <mat-label>{{'account.changeLoginName' | transloco}}</mat-label>
        <input inputrestriction="login" matInput spellcheck="false" type="text" name="m_user" [(ngModel)]="loginName" placeholder="" required autofocus>
    </mat-form-field>
    <br/>
    <br/>
    <button type="submit" (click)="onChangeUserName()" class="sub" mat-stroked-button color="primary">
        {{'account.changeLoginName' | transloco}}
        <mat-icon style="font-size: 1.3em; position: absolute; right: 10px">vpn_key</mat-icon>
    </button>
    <br/>
    <br/>
    <br/>
</div>
